import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const DiscoverSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('discover');

    // Get the discover content data
    const discoverData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('discover')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!discoverData) {
        return (
            <section className="section discover-area bg-gray overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No discover content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section discover-area bg-gray overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-between align-items-center">
                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        {/* Discover Thumb */}
                        <div className="service-thumb discover-thumb mx-auto pt-5 pt-lg-0">
                            <img src={discoverData.thumbOne} alt="" />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 order-1 order-lg-2">
                        {/* Discover Text */}
                        <div className="discover-text pt-4 pt-lg-0">
                            <h2 className="pb-4 pb-sm-0">{discoverData.heading}</h2>
                            <p className="d-none d-sm-block pt-3 pb-4">{discoverData.headingText}</p>
                            {/* Check List */}
                            <ul className="check-list">
                                {discoverData.discoverData && discoverData.discoverData.map((item, idx) => (
                                    <li key={`do_${idx}`} className="py-2">
                                        {/* List Box */}
                                        <div className="list-box media">
                                            <span className="icon align-self-center"><i className={item.iconClass} /></span>
                                            <span className="media-body pl-2">{item.text}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            <div className="icon-box d-flex mt-3">
                                {discoverData.discoverIcon && discoverData.discoverIcon.map((item, idx) => (
                                    <div key={`il_${idx}`} className="service-icon pr-3">
                                        <span><i className={item.iconClass} /></span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DiscoverSection;